import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesFieldSchemesAddRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-field-schemes-add',
	path: '/secure/admin/AddFieldConfigurationScheme!default.jspa',
};
